import React from 'react'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { Box, Grid, Paper, Typography } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import StatusAPI from 'api/faber/StatusAPI'
import PageLayoutV2 from 'common/Layout/Page/PageLayoutV2'

export default function FaberStatusDashboard() {
  const [stripeStatus, setStripeStatus] = useState('NOT OPERATIONAL')
  //mock data
  const workflows = [
    { name: 'Subscription', status: 'OPERATIONAL' },
    { name: 'Top Up', status: 'NOT OPERATIONAL' },
    { name: 'OTT Login', status: 'OPERATIONAL' },
    { name: 'OTP Login', status: 'OPERATIONAL' },
    { name: 'Voucher Redemption', status: 'OPERATIONAL' }
  ]
  const services = [
    { name: 'Stripe', status: stripeStatus },
    { name: 'Telna', status: 'OPERATIONAL' },
    { name: 'Expedia', status: 'OPERATIONAL' }
  ]

  const { data } = useQuery(
    ['getStripeStatus', 'getPaymentStatus'],
    async () => {
      setStripeStatus('OPERATIONAL')
      const res1 = StatusAPI.getStripeStatus()
      const res2 = StatusAPI.getPaymentStatus()
      return { Stripe: res1, Payment: res2 }
    },
    {
      onError: () => {
        setStripeStatus('NOT OPERATIONAL')
        toast.error('Error getting stripe status')
        return 'error'
      }
    }
  )
  //for testing, will be removed later
  console.log('Status', data)

  return (
    <PageLayoutV2 header='Status - Faber'>
      <Box>
        <Typography variant='h4' sx={{ my: 4 }}>
          Workflows
        </Typography>
        <Grid container spacing={4}>
          {workflows.map((workflow, index) => (
            <Grid key={index} item xs={6}>
              <Paper
                elevation={1}
                sx={{
                  p: 4,
                  borderRadius: '8px'
                }}
              >
                <Typography variant='h5'>{workflow.name}</Typography>
                <Box
                  sx={{
                    backgroundColor:
                      workflow.status === 'OPERATIONAL' ? '#34B37E' : '#EFC04D',

                    py: 1,
                    px: 2,
                    borderRadius: '8px',
                    width: 'fit-content'
                  }}
                >
                  <Typography
                    sx={{
                      color: 'white',
                      fontSize: '14px',
                      p: 0,
                      m: 0
                    }}
                  >
                    <b>{workflow.status}</b>
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
        <Typography variant='h4' sx={{ my: 4 }}>
          Services
        </Typography>
        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid key={index} item xs={6}>
              <Paper
                elevation={1}
                sx={{
                  p: 4,
                  br: 2
                }}
              >
                <Typography variant='h5'>{service.name}</Typography>
                <Box
                  sx={{
                    backgroundColor:
                      service.status === 'OPERATIONAL' ? '#34B37E' : '#EFC04D',

                    py: 1,
                    px: 2,
                    borderRadius: '8px',
                    width: 'fit-content'
                  }}
                >
                  <Typography
                    sx={{
                      color: 'white',
                      fontSize: '14px',
                      p: 0,
                      m: 0
                    }}
                  >
                    <b>{service.status}</b>
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </PageLayoutV2>
  )
}
